import {
  AlertTriangle, BadgeCheck, Wrench, ClipboardCheck, Cog, Paintbrush,
  Gauge, UserCheck, FileSearch, CarFront, OctagonAlert, Stamp, Truck,
} from "lucide-react";
import { EXCEL_VEHICLES } from "./excelVehicles";

export const EVENT_META = {
  tescil: { label: "Tescil", Icon: Stamp, color: "text-sky-400", ring: "border-sky-500/40 bg-sky-500/10" },
  kaza: { label: "Kaza Kaydı", Icon: CarFront, color: "text-red-400", ring: "border-red-500/40 bg-red-500/10" },
  hasar: { label: "Hasar Kaydı", Icon: AlertTriangle, color: "text-amber-400", ring: "border-amber-500/40 bg-amber-500/10" },
  km_anomali: { label: "KM Tutarsızlığı", Icon: OctagonAlert, color: "text-red-400", ring: "border-red-500/40 bg-red-500/10" },
  servis: { label: "Servis / Bakım", Icon: Wrench, color: "text-emerald-400", ring: "border-emerald-500/40 bg-emerald-500/10" },
  muayene: { label: "Muayene", Icon: ClipboardCheck, color: "text-cyan-400", ring: "border-cyan-500/40 bg-cyan-500/10" },
  parca_degisimi: { label: "Parça Değişimi", Icon: Cog, color: "text-slate-300", ring: "border-slate-400/40 bg-slate-400/10" },
  boya: { label: "Boya İşlemi", Icon: Paintbrush, color: "text-amber-300", ring: "border-amber-400/40 bg-amber-400/10" },
  km_okuma: { label: "KM Okuması", Icon: Gauge, color: "text-sky-300", ring: "border-sky-400/40 bg-sky-400/10" },
  sahiplik: { label: "Sahiplik", Icon: UserCheck, color: "text-violet-300", ring: "border-violet-400/40 bg-violet-400/10" },
  ekspertiz: { label: "Ekspertiz", Icon: FileSearch, color: "text-emerald-300", ring: "border-emerald-400/40 bg-emerald-400/10" },
  cekici: { label: "Çekici / Kurtarma", Icon: Truck, color: "text-orange-300", ring: "border-orange-400/40 bg-orange-400/10" },
};

export const TOW_STATUS = {
  bekliyor: { label: "Bekliyor", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  kabul_edildi: { label: "Kabul Edildi", cls: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30" },
  yolda: { label: "Yolda", cls: "bg-violet-500/10 text-violet-300 border-violet-500/30" },
  reddedildi: { label: "Reddedildi", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
  tamamlandi: { label: "Tamamlandı", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
};

export const QUOTE_STATUS = {
  bekliyor: { label: "Bekliyor", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  teklif_geldi: { label: "Teklif Geldi", cls: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30" },
  gorusuluyor: { label: "Görüşülüyor", cls: "bg-violet-500/10 text-violet-300 border-violet-500/30" },
  kabul_edildi: { label: "Kabul Edildi", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  tamamlandi: { label: "Tamamlandı", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  iptal: { label: "İptal", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
};

export const TOW_REASONS = ["Arıza", "Kaza", "Yolda Kalma", "Lastik", "Akü", "Diğer"];

export const SERVICE_CATEGORIES = [
  "Motor", "Elektrik", "Lastik", "Fren", "Klima", "Kaporta", "Şanzıman", "Genel Servis", "Diğer",
];

export const PROVIDER_STATUS = {
  bekliyor: { label: "Doğrulama Bekliyor", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  onayli: { label: "Onaylandı", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  reddedildi: { label: "Reddedildi", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
  pasif: { label: "Pasif", cls: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
};

export const WORK_DAYS = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];

export const FAMILY_LABELS = { cekici: "Çekici / Yol Yardım", servis: "Servis / Bakım", diger: "İşletme" };

export function slugify(s) {
  return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

export function fmtDistance(km) {
  if (km === null || km === undefined) return null;
  const dk = Math.max(3, Math.round((km / 40) * 60));
  return `${String(km).replace(".", ",")} km – Yaklaşık ${dk} dk`;
}

export const SERVICE_TYPES = [
  "Periyodik Bakım", "Motor Onarımı", "Fren Sistemi", "Şanzıman", "Elektrik / Elektronik",
  "Kaporta / Boya", "Lastik", "Klima", "Ekspertiz", "Diğer",
];

export const EVENT_TYPES_FOR_FORM = [
  { value: "servis", label: "Servis / Bakım" },
  { value: "muayene", label: "Muayene" },
  { value: "kaza", label: "Kaza" },
  { value: "hasar", label: "Hasar" },
  { value: "boya", label: "Boya" },
  { value: "parca_degisimi", label: "Parça Değişimi" },
  { value: "ekspertiz", label: "Ekspertiz" },
  { value: "km_okuma", label: "Kilometre Okuması" },
];

export const PAINT_PARTS = [
  { key: "on_tampon", label: "Ön Tampon" },
  { key: "kaput", label: "Ön Kaput" },
  { key: "sag_on_camurluk", label: "Sağ Ön Çamurluk" },
  { key: "sol_on_camurluk", label: "Sol Ön Çamurluk" },
  { key: "sag_on_kapi", label: "Sağ Ön Kapı" },
  { key: "sol_on_kapi", label: "Sol Ön Kapı" },
  { key: "sag_arka_kapi", label: "Sağ Arka Kapı" },
  { key: "sol_arka_kapi", label: "Sol Arka Kapı" },
  { key: "sag_arka_camurluk", label: "Sağ Arka Çamurluk" },
  { key: "sol_arka_camurluk", label: "Sol Arka Çamurluk" },
  { key: "tavan", label: "Tavan" },
  { key: "bagaj_kapagi", label: "Bagaj Kapağı" },
  { key: "arka_tampon", label: "Arka Tampon" },
  { key: "sasi", label: "Şasi" },
  { key: "direk", label: "Direk" },
  { key: "panel", label: "Panel" },
  { key: "podye", label: "Podye" },
];

export const PAINT_META = {
  orijinal: { label: "Orijinal / Sağlam", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  lokal_boya: { label: "Lokal Boyalı", cls: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30" },
  boyali: { label: "Boyalı", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  degisen: { label: "Değişen", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
  hasarli: { label: "Hasarlı", cls: "bg-orange-500/10 text-orange-400 border-orange-500/30" },
  islem_gormus: { label: "İşlem Görmüş", cls: "bg-violet-500/10 text-violet-300 border-violet-500/30" },
  belirtilmedi: { label: "Belirtilmedi", cls: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
  diger: { label: "Diğer", cls: "bg-slate-500/10 text-slate-300 border-slate-500/30" },
};

export const PAINT_STATUS_OPTIONS = [
  { value: "orijinal", label: "Orijinal / Sağlam" },
  { value: "lokal_boya", label: "Lokal Boyalı" },
  { value: "boyali", label: "Boyalı" },
  { value: "degisen", label: "Değişen" },
  { value: "hasarli", label: "Hasarlı" },
  { value: "islem_gormus", label: "İşlem Görmüş" },
  { value: "belirtilmedi", label: "Belirtilmedi" },
  { value: "diger", label: "Diğer" },
];

export const MECH_ITEMS = [
  { key: "motor", label: "Motor" },
  { key: "sanziman", label: "Şanzıman" },
  { key: "debriyaj", label: "Debriyaj" },
  { key: "fren_sistemi", label: "Fren Sistemi" },
  { key: "fren_balatalari", label: "Fren Balataları" },
  { key: "fren_diskleri", label: "Fren Diskleri" },
  { key: "suspansiyon", label: "Süspansiyon" },
  { key: "amortisorler", label: "Amortisörler" },
  { key: "direksiyon", label: "Direksiyon" },
  { key: "rot_balans", label: "Rot / Balans" },
  { key: "sogutma_sistemi", label: "Soğutma Sistemi" },
  { key: "egzoz", label: "Egzoz" },
  { key: "triger", label: "Triger" },
  { key: "motor_yagi", label: "Motor Yağı" },
  { key: "yag_filtresi", label: "Yağ Filtresi" },
  { key: "hava_filtresi", label: "Hava Filtresi" },
  { key: "yakit_filtresi", label: "Yakıt Filtresi" },
];

export const ELEC_ITEMS = [
  { key: "aku", label: "Akü" },
  { key: "klima", label: "Klima" },
  { key: "farlar", label: "Farlar" },
  { key: "stoplar", label: "Stoplar" },
  { key: "sinyaller", label: "Sinyaller" },
  { key: "multimedya", label: "Multimedya" },
  { key: "merkezi_kilit", label: "Merkezi Kilit" },
  { key: "camlar", label: "Camlar" },
  { key: "park_sensorleri", label: "Park Sensörleri" },
  { key: "geri_gorus_kamerasi", label: "Geri Görüş Kamerası" },
  { key: "sensorler", label: "Sensörler" },
  { key: "gosterge_paneli", label: "Gösterge Paneli" },
];

export const CHECK_STATUS_OPTIONS = [
  { value: "iyi", label: "İyi" },
  { value: "orta", label: "Orta" },
  { value: "bakim_gerekli", label: "Bakım Gerekli" },
  { value: "arizali", label: "Arızalı" },
  { value: "kontrol_edilmedi", label: "Kontrol Edilmedi" },
];

export const CHECK_STATUS_META = {
  iyi: { label: "İyi", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  orta: { label: "Orta", cls: "bg-lime-500/10 text-lime-300 border-lime-500/30" },
  bakim_gerekli: { label: "Bakım Gerekli", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  arizali: { label: "Arızalı", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
  kontrol_edilmedi: { label: "Kontrol Edilmedi", cls: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
};

export const TIRE_POSITIONS = [
  { key: "sol_on", label: "Sol Ön" },
  { key: "sag_on", label: "Sağ Ön" },
  { key: "sol_arka", label: "Sol Arka" },
  { key: "sag_arka", label: "Sağ Arka" },
];

export const TIRE_CONDITIONS = ["İyi", "Orta", "Değişmeli", "Belirtilmedi"];

export const PHOTO_CATEGORIES = [
  { value: "on", label: "Ön" },
  { value: "arka", label: "Arka" },
  { value: "sag_taraf", label: "Sağ Taraf" },
  { value: "sol_taraf", label: "Sol Taraf" },
  { value: "ic_mekan", label: "İç Mekan" },
  { value: "motor", label: "Motor" },
  { value: "bagaj", label: "Bagaj" },
  { value: "hasar", label: "Hasar" },
  { value: "kaporta", label: "Kaporta" },
  { value: "diger", label: "Diğer" },
];

export const SEVERITY_LABELS = { low: "Hafif", medium: "Orta", severe: "Ağır" };

export function scoreColor(score) {
  if (score >= 80) return "#10B981";
  if (score >= 60) return "#84CC16";
  if (score >= 40) return "#F59E0B";
  return "#EF4444";
}

export function fmtDate(d) {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return d; }
}

export function fmtKm(km) {
  if (km === null || km === undefined) return "-";
  return `${Number(km).toLocaleString("tr-TR")} km`;
}

export function belgeTarih(b) {
  const src = b || {};
  const norm = (x) => (typeof x === "string" ? { baslangic: "", bitis: x } : { baslangic: "", bitis: "", dosya: "", ...(x || {}) });
  return { sigorta: norm(src.sigorta), kasko: norm(src.kasko), muayene: norm(src.muayene) };
}

export const BELGE_EXTRAS = [
  { key: "ruhsat", label: "Ruhsat" },
  { key: "ekspertiz", label: "Ekspertiz Raporu" },
  { key: "fatura", label: "Fatura / Alış Belgesi" },
  { key: "servis_belgesi", label: "Servis Belgesi" },
  { key: "diger", label: "Diğer Belgeler" },
];

export function belgeEk(b, key) {
  const x = (b || {})[key];
  return { tarih: "", belge_no: "", not: "", dosya: "", ...(typeof x === "object" && x ? x : {}) };
}

export function belgeDurumu(bitis) {
  if (!bitis) return { label: "Belirtilmedi", cls: "text-slate-500 border-white/10", days: null };
  const d = new Date(`${bitis}T00:00:00`);
  if (Number.isNaN(d.getTime())) return { label: "Belirtilmedi", cls: "text-slate-500 border-white/10", days: null };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { label: "SÜRESİ DOLDU", cls: "text-red-400 border-red-500/50 bg-red-500/10", days };
  if (days <= 30) return { label: "SÜRESİ YAKLAŞIYOR", cls: "text-amber-300 border-amber-500/40 bg-amber-500/10", days };
  return { label: "AKTİF", cls: "text-emerald-400 border-emerald-500/30 bg-emerald-500/5", days };
}

export function fmtDateShort(iso) {
  if (!iso) return "—";
  const parts = String(iso).split("-");
  return parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : iso;
}


export function fmtTry(n) {
  if (n === null || n === undefined) return null;
  return `${Number(n).toLocaleString("tr-TR")} ₺`;
}

export const trUpper = (s) => (s || "").toLocaleUpperCase("tr-TR");

export const BODY_TYPES = ["Sedan", "Hatchback", "Station Wagon", "Combi", "SUV", "Pickup", "Panelvan", "Minibüs", "Kamyonet", "Coupe", "Cabrio", "Diğer"];

export const TRIM_CATALOG = {
  FORD: ["TREND", "TREND X", "STYLE", "TITANIUM", "TITANIUM PLUS", "ACTIVE", "ST-LINE"],
  FIAT: ["EASY", "URBAN", "LOUNGE", "CROSS", "S-DESIGN", "MIRROR"],
  RENAULT: ["JOY", "TOUCH", "ICON", "TECHNO", "ESPRIT ALPINE"],
  DACIA: ["COMFORT", "EXTREME", "JOURNEY", "ESSENTIAL"],
  VOLKSWAGEN: ["TRENDLINE", "COMFORTLINE", "HIGHLINE", "STYLE", "ELEGANCE", "R-LINE"],
  TOYOTA: ["VISION", "DREAM", "FLAME", "PASSION", "PREMIUM"],
  HYUNDAI: ["STYLE", "SMART", "ELITE", "PREMIUM", "N LINE"],
  OPEL: ["ESSENTIA", "EDITION", "ELEGANCE", "GS LINE", "ULTIMATE"],
  PEUGEOT: ["ACTIVE", "ALLURE", "GT", "GT LINE", "STYLE"],
  CITROEN: ["FEEL", "SHINE", "E-SERIES", "MAX"],
  HONDA: ["DREAM", "PREMIUM", "EXECUTIVE", "ELEGANCE"],
  NISSAN: ["VISIA", "TEKNA", "N-CONNECTA", "ACENTA"],
  SKODA: ["ACTIVE", "AMBITION", "STYLE", "SELECTION"],
  SEAT: ["REFERENCE", "STYLE", "FR", "XCELLENCE"],
  KIA: ["BASIC", "COOL", "PRESTIGE", "GT-LINE"],
  BMW: ["STANDART", "LUXURY LINE", "M SPORT", "M PERFORMANCE"],
  "MERCEDES-BENZ": ["STYLE", "AVANTGARDE", "AMG LINE", "EXCLUSIVE"],
  MERCEDES: ["STYLE", "AVANTGARDE", "AMG LINE", "EXCLUSIVE"],
  AUDI: ["BASIC", "ADVANCED", "S LINE", "DESIGN"],
  VOLVO: ["MOMENTUM", "INSCRIPTION", "R-DESIGN", "CORE", "PLUS", "ULTIMATE"],
  MITSUBISHI: ["INVITE", "INTENSE", "INSTYLE"],
};

export function trimsFor(brand) {
  const base = TRIM_CATALOG[trUpper(brand).trim()] || [];
  const d = EXCEL_VEHICLES[trUpper(brand).trim()];
  if (!d) return base;
  const s = new Set(base);
  Object.values(d).forEach((m) => (m.paket || []).forEach((v) => s.add(v)));
  return [...s];
}

export const VEHICLE_DELETE_NOTE = "Araç kaydınızı oluşturduktan sonra 24 saat içinde silebilirsiniz. 24 saat sonrasında kaydınızı siz silemezsiniz.";

// 24 saat kurali icin kalan duzenleme suresi; sure dolmussa null doner
export function editTimeLeft(ts) {
  if (!ts) return null;
  const end = new Date(ts).getTime() + 24 * 3600 * 1000;
  const ms = end - Date.now();
  if (ms <= 0) return null;
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return h > 0 ? `${h} sa ${m} dk` : `${m} dk`;
}

export function vehicleDeleteRemainingMs(createdAt) {
  if (!createdAt) return null;
  const created = new Date(createdAt).getTime();
  if (!created) return null;
  return Math.max(0, created + 24 * 3600 * 1000 - Date.now());
}

export function fmtHourMin(ms) {
  const totalMin = Math.ceil(ms / 60000);
  return `${Math.floor(totalMin / 60)} sa ${totalMin % 60} dk`;
}
